import AppSettingController from "../../../Main/controller/AppSettingController";
import {useTranslation} from "react-i18next";

export default function ToggleCustomBuy() {
    const {t} = useTranslation()
    const setting = AppSettingController.getSetting();

    return (
        <section>
            <div className={"dark-mode"}>
                <p>{t("setting.customBuy")}</p>
                <div className={"dark-mode-toggle"}>
                    <label className="switch">
                        <input type="checkbox"
                               checked={setting.customBuy}
                               onChange={() => AppSettingController.toggleActiveCustomBuy()}/>
                        <span className="slider round"></span>
                    </label>
                </div>
            </div>
        </section>
    )
}